import React from "react";

const Documents = ({ data, setTab, setType, setRefresh, refresh }) => {
  return (
    <div className="view-r-tab-content">
      <div className="view-r-section">
        <h3 className="view-r-section-title">Uploaded Documents</h3>

        <div className="view-r-document-list">
          <table className="view-r-table">
            <thead>
              <tr>
                <th>Document Name</th>
                <th>Upload Date</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(data) && data.length > 0 ? (
                data.map((doc) => (
                  <tr key={doc.id}>
                    <td>{doc.name}</td>
                    <td>{doc.date}</td>
                    <td>
                      <span
                        className={`view-r-status ${doc.status.toLowerCase()}`}
                      >
                        {doc.status}
                      </span>
                    </td>
                    <td>
                      <div className="view-r-actions">
                        <button className="view-r-btn-icon">
                          <i className="fa fa-eye"></i>
                          View
                        </button>
                        <button className="view-r-btn-icon">
                          <i className="fa fa-download"></i>
                          Download
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No documents available</td>
                </tr>
              )}

              {/* Mock data for visual representation when data is empty */}
              {(!Array.isArray(data) || data.length === 0) && (
                <>
                  <tr>
                    <td>Institution Certificate</td>
                    <td>2025-01-15</td>
                    <td>
                      <span className="view-r-status verified">Verified</span>
                    </td>
                    <td>
                      <div className="view-r-actions">
                        <button className="view-r-btn-icon">
                          <i className="fa fa-eye"></i>
                          View
                        </button>
                        <button className="view-r-btn-icon">
                          <i className="fa fa-download"></i>
                          Download
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Accreditation Documents</td>
                    <td>2025-01-16</td>
                    <td>
                      <span className="view-r-status pending">Pending</span>
                    </td>
                    <td>
                      <div className="view-r-actions">
                        <button className="view-r-btn-icon">
                          <i className="fa fa-eye"></i>
                          View
                        </button>
                        <button className="view-r-btn-icon">
                          <i className="fa fa-download"></i>
                          Download
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Faculty Details</td>
                    <td>2025-01-14</td>
                    <td>
                      <span className="view-r-status verified">Verified</span>
                    </td>
                    <td>
                      <div className="view-r-actions">
                        <button className="view-r-btn-icon">
                          <i className="fa fa-eye"></i>
                          View
                        </button>
                        <button className="view-r-btn-icon">
                          <i className="fa fa-download"></i>
                          Download
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Program Curriculum</td>
                    <td>2025-01-17</td>
                    <td>
                      <span className="view-r-status rejected">Rejected</span>
                    </td>
                    <td>
                      <div className="view-r-actions">
                        <button className="view-r-btn-icon">
                          <i className="fa fa-eye"></i>
                          View
                        </button>
                        <button className="view-r-btn-icon">
                          <i className="fa fa-download"></i>
                          Download
                        </button>
                      </div>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="view-r-section">
        <h3 className="view-r-section-title">Document Verification Notes</h3>
        <div className="view-r-notes">
          <div className="view-r-note-item">
            <h4>Accreditation Documents</h4>
            <p>
              Pending verification of regional accreditation status. Awaiting
              confirmation from accreditation board.
            </p>
            <div className="view-r-note-meta">
              <span>Added by: Mark Johnson</span>
              <span>Date: 2025-01-16</span>
            </div>
          </div>
          <div className="view-r-note-item">
            <h4>Program Curriculum</h4>
            <p>
              Document rejected. Incomplete curriculum details for graduate
              programs. Please resubmit with complete program information.
            </p>
            <div className="view-r-note-meta">
              <span>Added by: Sarah Williams</span>
              <span>Date: 2025-01-17</span>
            </div>
          </div>
        </div>
      </div>

      <div className="view-r-buttons">
        <button
          className="btn-outline-purple"
          onClick={() => {
            setTab(1);
            setType("RepresentativeDetails");
          }}
        >
          Back: Representative Details
        </button>
        <button
          className="btn-purple"
          onClick={() => {
            setTab(3);
            setType("SignedData");
          }}
        >
          Next: Signed Data
        </button>
      </div>
    </div>
  );
};

export default Documents;
